// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__vajDC","horizontal":"Menu_horizontal__osspR","bordered":"Menu_bordered__YgqPm","vertical":"Menu_vertical__D8LXL","closed":"Menu_closed__Vmw2J"};